export default __webpack_public_path__ + "static/media/polgo-screenshot-01.1a00a934.png";